import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChamaContributions } from '../../../features/fetch/fetchSlice';
import { Table } from 'antd';
import dayjs from 'dayjs';
import TableLoading from '../../../components/TableLoading';
import { useNavigate } from 'react-router-dom';
import { handleActiveContributionType } from '../../../features/obj/objSlice';
import { formatMoney } from '../../../utils';

export default function GroupContributionTypeTable({ limit }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { activeChama } = useSelector((state) => state.obj);
    const { chamaContributions, loading } = useSelector((state) => state.fetch);
    const { memberRole } = useSelector((state) => state.auth);

    async function handleInit() {
        await dispatch(fetchChamaContributions(activeChama?.custId));
    }

    async function handleSetActiveContributionType(item) {
        await dispatch(handleActiveContributionType(item));
        await navigate(`/contribution/types/overview/${item?.rdnType}`);
    }

    useEffect(() => {
        handleInit();
    }, []);

    useEffect(() => {}, [chamaContributions]);

    const columns = [
        {
            title: 'Type of contribution',
            dataIndex: 'rdnType',
        },
        {
            title: 'Amount (KES)',
            dataIndex: 'rdnAmount',
            render: (item) => <span>{formatMoney(item, 'KES')}</span>,
        },
        {
            title: 'Frequency',
            dataIndex: 'rdnFrequencyDescription',
        },
        {
            title: 'Contribution day',
            dataIndex: 'rdnContributionDay',
        },
        {
            title: 'Contribution start date',
            dataIndex: 'rdnStartDate',
            render: (item) => <span>{dayjs(item).format('Do MMM YYYY')}</span>,
        },
        {
            title: 'Action',
            render: (item) =>
                memberRole === 'MEMBER' ? (
                    <span> - </span>
                ) : (
                    <button onClick={() => handleSetActiveContributionType(item)} type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
                            <path
                                d="M9.69922 2.23333C12.9724 2.23333 15.8915 4.07933 17.3165 7C15.8915 9.92067 12.981 11.7667 9.69922 11.7667C6.4174 11.7667 3.50695 9.92067 2.08195 7C3.50695 4.07933 6.42604 2.23333 9.69922 2.23333ZM9.69922 0.5C5.38104 0.5 1.69331 3.19533 0.199219 7C1.69331 10.8047 5.38104 13.5 9.69922 13.5C14.0174 13.5 17.7051 10.8047 19.1992 7C17.7051 3.19533 14.0174 0.5 9.69922 0.5ZM9.69922 4.83333C10.891 4.83333 11.8583 5.804 11.8583 7C11.8583 8.196 10.891 9.16667 9.69922 9.16667C8.5074 9.16667 7.54013 8.196 7.54013 7C7.54013 5.804 8.5074 4.83333 9.69922 4.83333ZM9.69922 3.1C7.5574 3.1 5.81286 4.85067 5.81286 7C5.81286 9.14933 7.5574 10.9 9.69922 10.9C11.841 10.9 13.5856 9.14933 13.5856 7C13.5856 4.85067 11.841 3.1 9.69922 3.1Z"
                                fill="#1D191B"
                            />
                        </svg>
                    </button>
                ),
        },
    ];

    if (loading) return <TableLoading />;

    return (
        <>
            <Table
                scroll={{
                    x: 1200,
                }}
                rowKey="rdnId"
                className="mt-[1.5rem]"
                pagination={{
                    defaultPageSize: 7,
                    hideOnSinglePage: true,
                    pageSizeOptions: [10, 20, 50, 100],
                }}
                columns={columns}
                dataSource={chamaContributions}
            />
        </>
    );
}
